import React from "react";
import cn from "classnames";
import styles from "./Steps.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";

const items = [
  {
    title: "Transmission des dossiers",
    color: "#39B7CD",
    images: "/images/content/download.svg",
  },
  {
    title: "Suivi des statuts des dossiers", 
    color: "#39B7CD",
    images: "/images/content/download.svg",
  },
  {
    title: "Synchronisation des échéanciers",
    color: "#39B7CD",
    images: "/images/content/whistle.svg",
  },
  {
    title: "Génération automatique des factures",
    color: "#39B7CD", 
    images: "/images/content/whistle.svg",
  },
  {
    title: "Envoi direct des factures aux OPCO",
    color: "#39B7CD",
    images: "/images/content/medal.svg",
  },
];

const Steps = ({ scrollToRef }) => {
  return (
    <div className={cn("section", styles.section)} ref={scrollToRef}>
      <div className={cn("container", styles.container)}>
        <div className={styles.head}>
          <h2 className={cn("h2", styles.title)}>Gestion automatique des dossiers</h2>
          <div className={styles.info}>
            Automatisez vos échanges avec les OPCO grâce à notre processus intégré en 5 étapes.
          </div>
        </div>
        <div className={styles.stepsContainer}>
          <div className={styles.stepsLine}>
            {items.map((x, index) => (
              <React.Fragment key={index}>
                <ScrollParallax className={styles.stepItem}>
                  <div
                    className={styles.stepIcon}
                    style={{ backgroundColor: x.color }}
                  >
                    <img src={x.images} alt={`Étape ${index + 1}`} />
                  </div>
                  <div className={styles.stepNumber}>Étape {index + 1}</div>
                  <div className={styles.stepTitle}>{x.title}</div>
                </ScrollParallax>
                {index < items.length - 1 && (
                  <div className={styles.stepConnector}>
                    <div className={styles.dashedLine}></div>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Steps;
